import * as d3 from 'd3'
export default {

  methods: {

    draw_Status() {

      let box =this.box

      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      let boxWidth = this.status.width + (box.padding*2)

      let x_ = 0
      let y_ = 0
      this.rawData.forEach((d,i)=> {

        let item = status
        .append('g')
        .attr('transform', `translate(${x_}, ${y_})`)

        item
        .append('rect')
        .attr('x', 0).attr('y', 0)
        .attr('rx', box.radius).attr('ry', box.radius)
        .attr('width', boxWidth).attr('height', box.height)
        .attr('fill', box.color).attr('fill-opacity', .2)
        .attr('stroke', '#bcbcbc').attr('stroke-width', box.sWidth)
        .attr('opacity', box.opacity)


        let name = this.status.name
        item
        .append('text')
        .attr('x', name.x).attr('y', name.y)
        .attr('fill', name.tColor).attr('font-size', name.tSize)
        .attr('text-anchor', name.align)
        .text(d[name.code])

        // Bar Chart
        item
        .append('rect')
        .attr('x',  box.padding).attr('y', this.bullet.y)
        .attr('width', this.status.width).attr('height', 3)
        .attr('fill', '#E0E0DF').attr('opacity', .5)

        item
        .append('rect')
        .attr('x',  box.padding).attr('y', this.bullet.y)
        .attr('width', (this.status.width/100) * d[this.status.pro.code]).attr('height', 3)
        .attr('fill', this.scale(i))
        .attr('opacity', box.prog.opacity)

        // Progress
        let pro = this.status.pro
        item
        .append('text')
        .attr('x', pro.x).attr('y', pro.y)
        .attr('fill', pro.tColor).attr('font-size', pro.tSize)
        .attr('text-anchor', pro.align)
        .text(d[pro.code] + pro.unit)


        // Columns
        let title = this.status.title
        let val = this.status.value

        this.status.columns.forEach(col=> {

          item
          .append('text')
          .attr('x', col.tx + val.x).attr('y', val.y)
          .attr('fill', col.tColor).attr('font-size', val.tSize)
          .attr('text-anchor', col.align)
          .text(d[col.code] + col.unit)
          .call(this.event_Link, d, col)

          item
          .append('text')
          .attr('x', col.tx + title.x).attr('y', title.y)
          .attr('fill', title.tColor).attr('font-size', title.tSize)
          .attr('text-anchor', d.align)
          .text(col.name)

        })






        x_ += (boxWidth + this.box.margin)

        if((i + 1) % this.box.count === 0) {
          x_ = 0
          y_ += this.box.height + this.box.margin
        }
      })

    },



    draw_Status2() {

      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.status.y})`)

      let bx = 0
      this.columns.forEach(d=> {

        if(d.code != this.status.totalRef) {
          let raWidth = (this.status.width * d.ratio)/this.status.ratio
          status
          .append('rect')
          .attr('x', bx).attr('y', -11).attr('rx', 3)
          .attr('width', raWidth).attr('height', 6)
          .attr('fill', d.bColor).attr('stroke-width', 0)
          bx = bx + raWidth
        }

        status
        .append('rect')
        .attr('x', d.sx).attr('y', 0)
        .attr('width', 2).attr('height', this.status.barHeight)
        .attr('fill', d.bColor).attr('stroke-width',0)
        .attr('opacity', 1)

        status // Name
        .append('text')
        .attr('x', d.sx + 5).attr('y', this.status.name.tSize*0.75)
        .attr('fill', this.status.name.tColor).attr('font-size', this.status.name.tSize)
        .attr('text-anchor', 'start')
        .text(d.name)

        status // Value
        .append('text')
        .attr('x', d.sx + 5).attr('y', this.status.value.y + this.status.value.tSize*0.75)
        .attr('fill', this.status.value.tColor).attr('font-size', this.status.value.tSize)
        .attr('text-anchor', 'start')
        .text(this.gmx_numFormat(d.value, '$') + this.status.value.unit)
        .call(this.event_Link, d)


        if(d.delta == 'Y') {
          status // Weekly Delta
          .append('text')
          .attr('x', d.ex -12).attr('y', this.status.week.tSize*0.75)
          .attr('fill', d.week>0 ? '#44A9DF' : '#EC407A').attr('font-size', this.status.week.tSize)
          .attr('text-anchor', 'end')
          .text(d.week + this.status.week.unit)

          status // Delta Icon
          .append('path')
          .attr('transform', `translate(${d.ex - 10}, 0) scale(.7)`)
          .attr('d', d.week>0 ? this.icon.cUp : this.icon.cDown)
          .attr('fill', d.week>0 ? '#44A9DF' : '#EC407A')
        }

      })

    },

  } 
}